import { useContext } from 'react';
import { createContext } from 'react';
import { useDisclosureLayout } from '../../DisclosureLayout/hooks/useDisclosureLayout';

import { DisclosureContentProps } from '../@types/DisclosureContentProps';

export const DisclosureContentContext = createContext<DisclosureContentProps>({} as DisclosureContentProps);

DisclosureContentContext.displayName = 'DisclosureContent';

const DisclosureContentProvider = ({ children, blockClass }: DisclosureContentProps) => {
	const { isOpen, animated, componentId } = useDisclosureLayout();
	const renderClass = () => {
		return blockClass
			? `content--${blockClass} content--${blockClass}--${isOpen ? 'visible' : 'hidden'} content--${blockClass} vtex-disclosure-layout-1-x-content--${blockClass}--${isOpen ? 'visible' : 'hidden'}`
			: '';
	};
	return (
		<div
			data-selection={componentId}
			{...(animated ? (isOpen ? { 'data-leave': '' } : { 'data-enter': '' }) : '')}
			{...(!isOpen ? { hidden: true } : {})}
			className={`content vtex-disclosure-layout-1-x-content ${renderClass()}`}
		>
			{children}
		</div>
	);
};

export const useDisclosureContent = () => {
	const context = useContext(DisclosureContentContext);

	return context;
};

export default DisclosureContentProvider;
